module.exports = __webpack_public_path__ + "img/done.f1d1fa45.png";